import EdroloLogo from './EdroloLogo';

export default EdroloLogo;
